import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
	Box, Drawer, Tabs, Tab, Typography
} from '@mui/material';
import '../Pages/Dashboard/OrganizationDashboard/pdfdetails-mobile.css';
import DownloadIcon from '../../Assets/Images/svgs/download.svg';
import GeneralModal from './Modal/GeneralModal/general-modal.js';

const CustomText = ({ title = '', value = '' }) => (
	<Box
		display='flex'
		alignItems='start'
		width='300px'
		justifyContent='space-between'
	>
		<Typography
			mt='10px'
			color='#8E8E8E'
			className={'medium11'}
			fontSize='15px'
			width='50%'
			sx={{ wordWrap: 'break-word' }}
		>
			{title}:
		</Typography>
		<Typography
			mt='10px'
			color='#D9D9D9'
			className={'medium11'}
			fontSize='15px'
			width='50%'
			sx={{ wordWrap: 'break-word' }}
		>
			{value}
		</Typography>
	</Box>
);

const PDFDetailsMobile = ({
	open = false,
	handleClose = () => {},
	data = {},
	handleUpdateClick,
	handleCloseConfirmation,
	handleOpenConfirmation,
	openConfirmation
}) => {
	const [selectedTab, setSelectedTab] = useState(1);
	const noDownloadIcon = ['Reserved', 'Available'];

	const handleChange = (event, newValue) => {
		setSelectedTab(newValue);
	};

	return (
		<Drawer
			anchor='bottom'
			open={open}
			onClose={handleClose}
			ModalProps={{ keepMounted: false }}
			sx={{
				'.MuiPaper-root': {
					height: 'calc(100vh - 150px)',
					overflow: 'visible',
					backgroundColor: '#000',
					color: '#fff',
					borderTopLeftRadius: '16px',
					borderTopRightRadius: '16px',
					padding: '5px 10px 0'
				}
			}}
		>
			<Box sx={{ width: '100%', height: '100%' }}>
				<Box sx={{ borderBottom: 1, borderColor: '#ECF0E5' }}>
					<Tabs
						value={selectedTab}
						onChange={handleChange}
						aria-label='basic tabs example'
						sx={{
							'.MuiTab-textColorPrimary': {
								color: '#ECF0E5'
							},
							'.MuiTabs-flexContainer': {
								justifyContent: 'space-around'
							}
						}}
					>
						<Tab label='Details' />
					</Tabs>
				</Box>
				<GeneralModal
					open={openConfirmation}
					onClose={handleCloseConfirmation}
					btn2OnClick={() => {
						handleCloseConfirmation();
						handleUpdateClick('used');
					}}
					genText={'Important Note!'}
					genTextClassName={'medium1'}
					btn1Text={'No, Cancel'}
					btn1OnClick={handleCloseConfirmation}
					no2btn={false}
					btn1BorderColor={'#fff'}
					btn1Color={'#0A0909'}
					btn2Text={'Proceed'}
				>
					<p className='medium5' style={{ marginTop: '20px' }}>
						Downloading this Stamp Paper will permanently mark its status as{' '}
						<b>Used</b>, and you will no longer be able to download or modify
						its status.
					</p>
				</GeneralModal>
				{selectedTab === 1 && (
					<Box sx={{ height: '100%', overflowY: 'auto' }}>
						<Box position='relative' pr='10px'>
							<Box
								display='flex'
								justifyContent='space-between'
								alignItems='center'
							>
								<Typography variant='h6' className={'medium11'}>
									Details
								</Typography>
								{noDownloadIcon.includes(data.status) && (
									<Box
										component={'img'}
										src={DownloadIcon}
										alt='Download Icon'
										style={{
											cursor: 'pointer',
											width: '50px',
											height: '40px',
											marginRight: '25px'
										}}
										onClick={() => {
											handleOpenConfirmation();
										}}
									/>
								)}
							</Box>

							<CustomText title='State ID' value={data.stateId} />
							<CustomText title='State Name' value={data.stateName} />
							<CustomText
								title='Stamp Certificate ID'
								value={data.stampCertificateId}
							/>
							<CustomText title='Status' value={data.status} />
							<CustomText
								title='Article Code'
								value={data?.articleCode || '-'}
							/>

							{data.remark.length > 0 && (
								<Box mt='20px' pb='90px'>
									<Typography variant='h6' className={'medium11'}>
										History
									</Typography>

									{data.remark.map((item, idx) => (
										<Box
											key={'inventory' + idx}
											sx={{
												border: '1px solid white',
												borderRadius: '10px',
												p: '10px 15px',
												mt: '10px'
											}}
										>
											<CustomText
												title='Transition From'
												value={item.transitionFrom}
											/>
											<CustomText title='Remarks' value={item.remark} />
											<CustomText title='Updated By' value={item.updateBy} />
											<CustomText title='Timestamp' value={item.updateAt} />
										</Box>
									))}
								</Box>
							)}
						</Box>
					</Box>
				)}
			</Box>
		</Drawer>
	);
};

export default PDFDetailsMobile;

PDFDetailsMobile.propTypes = {
	open: PropTypes.any,
	handleClose: PropTypes.any,
	data: PropTypes.any,
	handleUpdateClick: PropTypes.any,
	handleCloseConfirmation: PropTypes.any,
	handleOpenConfirmation: PropTypes.any,
	openConfirmation: PropTypes.any
};

CustomText.propTypes = {
	title: PropTypes.any,
	value: PropTypes.any
};
